interface LoaderProps {
  text?: string;
}

const Loader = (props: LoaderProps) => {
  const { text } = props;
  return (
    <div className="flex items-center font-bold flex-col text-lf-blue-dark min-h-fit py-12">
      <span className="inline-block w-9 h-9 border-4 border-gray-300 border-b-lf-blue-dark rounded-full animate-spin"></span>
      <p>Loading {text}</p>
    </div>
  );
};

Loader.displayName = "Loader";

export default Loader;
